module.exports = __webpack_public_path__ + "media/images/web/landings/teachers/s3-55169bf5a989a61a886bf4c6674fb45a.jpg";